export const aiChatData = ({ aiChatReducer }) => aiChatReducer;
